import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import Immutable from 'seamless-immutable';
import * as reducers from './reducers';
import { reducer as oidc } from 'redux-oidc';
import { previousPathMiddleware } from './helpers/Middleware';

export default function configureStore(history = {}, initialState = Immutable({})) {
	// Build middleware. These are functions that can process the actions before they reach the store.
	const windowIfDefined = typeof window === 'undefined' ? null : window;
	// If devTools is installed, connect to it
	const isDevelopment = process.env.NODE_ENV === 'development';
	const devToolsExtension = isDevelopment && windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__;
	const sagaMiddleware = createSagaMiddleware();
	const createStoreWithMiddleware = compose(
		applyMiddleware(sagaMiddleware, routerMiddleware(history), previousPathMiddleware),
		devToolsExtension ? devToolsExtension() : (next) => next
	)(createStore);

	// Combine all reducers and instantiate the app-wide store instance
	const allReducers = buildRootReducer(reducers);
	const store = createStoreWithMiddleware(allReducers, initialState);
	store.runSaga = sagaMiddleware.run;
	store.close = () => store.dispatch(END);

	// Enable Webpack hot module replacement for reducers
	if (module.hot) {
		module.hot.accept('./reducers', () => {
			const nextRootReducer = require('./reducers');
			store.replaceReducer(buildRootReducer(nextRootReducer));
		});
	}

	return store;
}

function buildRootReducer(anyReducers) {
	return combineReducers(Object.assign({ oidc }, anyReducers, { routing: routerReducer }, { toastr: toastrReducer }));
}
